// src/components/dashboard/PendingOrdersWidget/PendingOrdersWidget.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tradingService } from '../../../services/tradingService';
import { copyTradingService } from '../../../services/copyTradingService';
import './PendingOrdersWidget.css';

const PendingOrdersWidget = () => {
  const navigate = useNavigate();
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingOrdersCount();
  }, []);

  const fetchPendingOrdersCount = async () => {
    try {
      // Fetch own pending limit orders AND pending copy trades in parallel.
      // Pending copy trades represent reserved funds waiting on a leader's
      // limit order to fill — they should surface in the widget count too.
      const [orders, copyTrades] = await Promise.all([
        tradingService.getUserOrders({ status: 'PENDING' }),
        copyTradingService.getMyCopyTrades(),
      ]);

      const pendingCopyCount = Array.isArray(copyTrades)
        ? copyTrades.filter(ct => ct.status === 'PENDING').length
        : 0;

      setPendingCount(orders.length + pendingCopyCount);
    } catch (err) {
      console.error('Error fetching pending orders:', err);
      setPendingCount(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pending-orders-widget-container">
      <button
        className="pending-orders-icon-button"
        onClick={() => navigate('/pending-orders')}
        title={
          pendingCount > 0
            ? `${pendingCount} pending order${pendingCount > 1 ? 's' : ''}`
            : 'No pending orders'
        }
      >
        {/* Hourglass Symbol */}
        <div className="hourglass-symbol">
          <div className="hourglass-top"></div>
          <div className="hourglass-middle"></div>
          <div className="hourglass-bottom"></div>
        </div>

        {/* Red dot indicator when there are pending orders */}
        {pendingCount > 0 && (
          <span className="pending-indicator">{pendingCount}</span>
        )}
      </button>

      <span className="widget-label">Pending Orders</span>
    </div>
  );
};

export default PendingOrdersWidget;